import React, { FC } from 'react'
import styles from './StreamOptionsMenuItem.module.scss'

import { InformationIcon } from 'components/Accordion/AccordionItem/InformationButton/InformationIcon'
import EditIcon from 'assets/icons/EditIcon'
import SettingsIcon from 'pages/ChannelPage/Header/Images/SettingsIcon'

import { DownloadIcon } from 'assets/icons/DownloadIcon'
import { FlagIcon } from 'assets/icons/FlagIcon'
import { HelpIcon } from 'assets/icons/HelpIcon'

const icons = {
  settings: SettingsIcon,
  download: DownloadIcon,
  flag: FlagIcon,
  help: HelpIcon,
  edit: EditIcon,
  broadcastInfo: InformationIcon
}

interface OptionsMenuItemProps {
  icon: 'settings' | 'download' | 'flag' | 'help' | 'broadcastInfo' | 'edit'
  onClick: () => void
  dataTestId: string
  children?: React.ReactNode
}

export const OptionsMenuItem: FC<OptionsMenuItemProps> = ({
  icon,
  children,
  dataTestId,
  onClick
}) => {
  const Icon = icons[icon]
  return (
    <div
      data-testid={dataTestId}
      className={styles.OptionsMenuItem}
      tabIndex={0}
      role="button"
      onKeyPress={() => null}
      onClick={onClick}
    >
      <Icon />
      <span>{children}</span>
    </div>
  )
}
